import { BaseService } from "./BaseService";
import { MenuRouteItem } from "@/components/menu/types";

class NavigationServiceClass extends BaseService {
    protected get baseUrl(): string {
        return `${process.env.NEXT_PUBLIC_API_URL}/api/navigation/`;
    }

    async getNavigationList(): Promise<MenuRouteItem[]> {
        return this.get("GetNavigationList");
    }

    async getNavigationListByUser(userId: number): Promise<MenuRouteItem[]> {
        return this.get(`GetNavigationListForUser/${userId}`);
    }
}

export const navigationService = new NavigationServiceClass();
